var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link?.href)?_c('CycleLink',_vm._b({},'CycleLink',_vm.componentData,false),[_vm._v(" "+_vm._s(_vm.linkText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }